import { DateTime } from "luxon";
import i18n from "../../../i18n";

interface ExcludedDate {
  id: string;
  startDate: string;
  endDate: string;
  roomIds: string[];
  reason: string;
  repeatAnnually: boolean;
}

export default ExcludedDate;

export const getRepeatAnnuallyString = (date: DateTime) => {
  return i18n.t("repeat-annually-on") + " " + i18n.t(`month-short-${date.monthLong}`) + ` ${date.day}`;
};
